import Vue from 'vue'
import { isArray, isObject, getKey } from '@/util'

const systemConfigGroup = {}

const endpointGroupMap = {
  VUX: [{
    text: "侧拉菜单管理",
    group: "drawer"
  }],
  ELEMENT_UI: [{
    text: '公共组件管理',
    group: 'page'
  }],
  FLUTTER: []
}

function getConfigApi (endpoint, group, name) {
  let configs = systemConfigGroup[`${endpoint}_${group}`]
  for (let config of configs) {
    if (config.name === name) {
      let result = JSON.parse(JSON.stringify(config))
      getArrayItem('id', result.properties).value = result.key = 'cmp_id_' + getKey()
      return result
    }
  }

  return null
}

// TODO 缓存api
function loadConfigApi (endpoint, group, callback) {
  let key = `${endpoint}_${group}`
  if (systemConfigGroup[key]) {
    callback(JSON.parse(JSON.stringify(systemConfigGroup[key])))
    return
  }

  let temp = window.location.href.split('/')
  let url = `${temp[0]}//${temp[2]}`
  Vue.prototype.$http.request({
    method: 'get',
    url: `${url}/config/${endpoint}/${group}.json`
  }).then((res) => {
    let apis = res.data
    for (let api of apis) {
      Vue.prototype.$http.request({
        method: 'get',
        url: `${url}/config/${endpoint}/${api.name}.json`
      }).then((res) => {
        api.config = res.data

        let completed = true
        for (let x of apis) {
          if (!x.config) {
            completed = false
            break
          }
        }
        if (completed) {
          let configs = mergeConfig(apis)
          systemConfigGroup[key] = configs

          callback(JSON.parse(JSON.stringify(configs)))
        }
      })
    }
  })
}

function mergeConfig (apis) {
  function sortP (config, property) {
    let array = config[property]
    if (array && array.length) {
      config[property] = array.sort(function (a, b) {
        return a.order - b.order
      })
    }
  }

  let configs = []
  for (let api of apis) {
    let config = JSON.parse(JSON.stringify(mergeParentConfig(api, apis)))
    config.apiType = api.type
    configs.push(config)

    sortP(config, 'properties')
    sortP(config, 'advancedProperties')
    sortP(config, 'methods')
    sortP(config, 'events')
    sortP(config, 'hooks')
  }

  return configs
}

function mergeParentConfig (api, apis) {
  let config = api.config
  let parentName = config.extend
  if (!parentName) {
    config.parents = []
    return config
  }

  let parentConfig
  for (let parent of apis) {
    if (parent.name === parentName) {
      config.parents = parent.config.parents.concat([parentName])
      parentConfig = mergeParentConfig(parent, apis)
      break
    }
  }

  mergeObject(parentConfig, config)

  return config
}

function mergeObject (source, target) {
  for (let p in source) {
    if (p === 'name' || p === 'extend' || p === 'parents' || p === 'desc') {
      continue
    }

    if (!source.hasOwnProperty(p)) {
      continue
    }

    let v = source[p]
    if (target.hasOwnProperty(p)) {
      if (isObject(v)) {
        mergeObject(v, target[p])
      } else if (isArray(v)) {
        if (p === 'values') {
          target[p] = target[p] || v
        } else {
          target[p] = mergeArray(v, target[p])
        }
      }
    } else {
      target[p] = v
    }
  }
}

function mergeArray (source, target) {
  for (let i of source) {
    if (!isObject(i)) {
      return
    }
  }
  for (let i of target) {
    if (!isObject(i)) {
      return
    }
  }

  let temp = []
  for (let s of source) {
    let count = 0
    let length = target.length
    for (let i = 0; i < length; i++) {
      let t = target[i]
      if (s.name === t.name) {
        mergeObject(s, t)
        temp.push(t)
        break
      }
      count++
    }

    if (count === length) {
      temp.push(s)
    }
  }

  for (let t of target) {
    let count = 0
    let length = temp.length
    for (let i = 0; i < length; i++) {
      let s = temp[i]
      if (s.name === t.name) {
        break
      }
      count++
    }
    if (count === length) {
      temp.push(t)
    }
  }

  return temp
}

function getArrayItem(name, array) {
  if (!name || !array || !array.length) {
    return null
  }

  for (let arr of array) {
    if (arr.name === name) {
      return arr
    }
  }

  return null
}

function getClosestByKeyAttr (el) {
  if (!el) {
    return null
  }

  if (el.hasAttribute('data-pc-key')) {
    if (el.getAttribute('data-pc-key') === 'none') {
      return null
    }
    return el
  }

  return getClosestByKeyAttr(el.parentNode)
}

function getComponentKey (target) {
  if (!target) {
    return null
  }

  target = getClosestByKeyAttr(target)
  if (!target) {
    return null
  }

  return target.getAttribute('data-pc-key')
}

function canDrop (endpoint, group, dragEl, dropEl) {
  let canDragTo
  let configs = systemConfigGroup[`${endpoint}_${group}`]
  for (let config of configs) {
    if (config.name === dragEl) {
      canDragTo = config.canDragTo
      break
    }
  }

  let canDropIn
  if (dropEl === 'root') {
    canDropIn = '*'
  } else {
    for (let config of configs) {
      if (config.name === dropEl) {
        canDropIn = config.canDropIn
        break
      }
    }
  }

  if (canDragTo === '*') {
    if (canDropIn === '*') {
      return true
    } else {
      return `,${canDropIn},`.indexOf(`,${dragEl},`) !== -1
    }
  } else {
    if (canDropIn === '*') {
      return `,${canDragTo},`.indexOf(`,${dropEl},`) !== -1
    } else {
      return `,${canDropIn},`.indexOf(`,${dragEl},`) !== -1 && `,${canDragTo},`.indexOf(`,${dropEl},`) !== -1
    }
  }
}

function translateConfigs (endpoint, group, configJson) {
  if (!configJson || !configJson.length) {
    return []
  }

  let configs = JSON.parse(configJson)
  if (!configs || !configs.length) {
    return []
  }

  let components = []
  for (let config of configs) {
    components.push(translateConfig(endpoint, group, config))
  }
  return components
}

function translateConfig (endpoint, group, config) {
  let systemConfig
  let configs = systemConfigGroup[`${endpoint}_${group}`]
  for (let sc of configs) {
    if (config.name === sc.name) {
      systemConfig = JSON.parse(JSON.stringify(sc))
      break
    }
  }

  if (config.extra) {
    systemConfig.extra = config.extra
  }

  setProperties(config.properties || [], systemConfig.properties || [])
  setProperties(config.advancedProperties || [], systemConfig.advancedProperties || [])
  setProperties(config.methods || [], systemConfig.methods || [])
  setProperties(config.events || [], systemConfig.events || [])
  setProperties(config.hooks || [], systemConfig.hooks || [])

  let children1 = []
  let children = config.children || []
  for (let child of children) {
    children1.push(translateConfig(endpoint, group, child))
  }
  systemConfig.children = children1

  systemConfig.key = 'cmp_id_' + getKey()

  return systemConfig
}

function setProperties (properties, properties1) {
  // 将已经设置的值赋值给properties1
  for (let property of properties) {
    for (let property1 of properties1) {
      if (property.name === property1.name) {
        property1.value = property.value
        break
      }
    }
  }
  // 将properties1中的默认值去除
  for (let property1 of properties1) {
    let found = false
    for (let property of properties) {
      if (property.name === property1.name) {
        found = true
        break
      }
    }
    if (!found) {
      property1.value = undefined
    }
  }
}

function getEndpoint (endpoint) {
  let endpoint1 = ''
  if (endpoint === 'element-ui') {
    endpoint1 = 'ELEMENT_UI'
  } else if (endpoint === 'vux') {
    endpoint1 = 'VUX'
  } else if (endpoint === 'flutter') {
    endpoint1 = 'FLUTTER'
  }
  return endpoint1
}

function getEndpointPath (endpoint) {
  let endpoint1 = ''
  if (endpoint === 'ELEMENT_UI') {
    endpoint1 = 'element-ui'
  } else if (endpoint === 'VUX') {
    endpoint1 = 'vux'
  } else if (endpoint === 'FLUTTER') {
    endpoint1 = 'flutter'
  }
  return endpoint1
}

function getDevice (endpoint) {
  let device = ''
  if (endpoint === 'element-ui') {
    device = 'PC'
  } else if (endpoint === 'vux') {
    device = 'MOBILE'
  } else if (endpoint === 'flutter') {
    device = 'MOBILE'
  }
  return device
}

function getApiType (endpoint, group, config) {
  let systemConfigs = systemConfigGroup[`${endpoint}_${group}`]
  for (let systemConfig of systemConfigs) {
    if (systemConfig.name === config.name) {
      return systemConfig.apiType || 'component'
    }
  }
  return null
}

function isComponent (endpoint, group, config) {
  let systemConfigs = systemConfigGroup[`${endpoint}_${group}`]
  for (let systemConfig of systemConfigs) {
    if (systemConfig.name === config.name) {
      if (systemConfig.apiType === 'component' || !systemConfig.apiType) {
        return true
      }
      break
    }
  }
  return false
}

function isContainer (endpoint, group, config) {
  let systemConfigs = systemConfigGroup[`${endpoint}_${group}`]
  for (let systemConfig of systemConfigs) {
    if (systemConfig.name === config.name) {
      if (systemConfig.apiType === 'container') {
        return true
      }
      break
    }
  }
  return false
}

function isFormControl(endpoint, group, config) {
  let systemConfigs = systemConfigGroup[`${endpoint}_${group}`]
  for (let systemConfig of systemConfigs) {
    if (systemConfig.name === config.name) {
      if (systemConfig.apiType === 'form-control') {
        return true
      }
      break
    }
  }
  return false
}

export { endpointGroupMap, loadConfigApi, getConfigApi, getArrayItem, getComponentKey, canDrop, translateConfigs, getEndpoint, getEndpointPath, getDevice, getApiType, isComponent, isContainer, isFormControl }
